import { useMemo } from 'react';

import { useLocalStorage } from './useLocalStorage';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';

export const useUserIsLogged = () => {
   const { value: authToken } = useLocalStorage(
    LOCAL_STORAGE_KEYS.AUTH_TOKEN,
  );

  const isLogged = useMemo(
    () => !!authToken,
    [ authToken],
  );

  return { isLogged, token: authToken };
}
